import React, { useState, useEffect } from 'react';
import { Alert } from '@nextiva/next-ui-components';

import { DIALOG_KINDS } from 'constants/dialogKinds';

import styles from './styles.scss';

const TimedAlert = ({
  setFireAlert,
  duration = 6000,
  onClose = () => {},
  ...passthrough
}) => {
  const [timer, setTimer] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [alertProps, setAlertProps] = useState({
    severity: DIALOG_KINDS.INFO,
    title: '',
  });
  const [alertMessage, setAlertMessage] = useState('');

  const closeAlert = () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setIsOpen(false);
    onClose();
  };

  const openAlert = (flavor = DIALOG_KINDS.INFO, title = '', message = '') => {
    setAlertProps({ title, severity: flavor });
    setAlertMessage(message);
    setIsOpen(true);
    setTimer(() => setTimeout(closeAlert, duration));
  };

  useEffect(() => {
    setFireAlert(() => openAlert);
  }, []);

  return (
    <>
      {isOpen && (
        <Alert
          className={styles.alert}
          onClose={closeAlert}
          {...alertProps}
          {...passthrough}
        >
          {alertMessage}
        </Alert>
      )}
    </>
  );
};

export default TimedAlert;
